import { inject, Injectable } from '@angular/core';
import { HttpService } from './http-service';

import { firstValueFrom, take, tap } from 'rxjs';
import { RsvpDataResponse } from '../dto/RsvpDataResponse';
import { RsvpData } from '../models/RsvpData';
import { AttendingStatus } from '../models/AttendingStatus.enum';
import { AuthService } from './auth-service';


@Injectable({
  providedIn: 'root',
})
export class RsvpService {

  private httpService: HttpService = inject(HttpService);
  private authService: AuthService = inject(AuthService);

  private readonly rsvpSubPath = '/rsvp';

  async getRsvpData(qrCodeData: string): Promise<RsvpDataResponse> {
    this.authService.askToRefreshIfNeeded();
    return this.httpService.getToPromise<RsvpDataResponse>(`${this.rsvpSubPath}/getFamilyData/${qrCodeData}`);
  }

  async saveRsvpData(qrCodeData: string, rsvpData: RsvpData): Promise<RsvpDataResponse> {

    this.authService.askToRefreshIfNeeded();
    return this.httpService.postToPromise<RsvpDataResponse>(`${this.rsvpSubPath}/saveFamilyRsvpData/${qrCodeData}`, JSON.stringify(rsvpData));
  }

}
